<template>
  <div class="table-container">
    <el-row :gutter="20">
      <el-col :xs="24" :sm="24" :md="12" :lg="24" :xl="24">
        <el-table ref="tableSort" v-loading="loading" :data="list" border>
          <el-table-column
            label="序号"
            align="center"
            width="80"
            prop="seq"
          ></el-table-column>
          <el-table-column label="立案时间" align="center">
            <template slot-scope="scope">
              {{ scope.row.date || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="案号">
            <template slot-scope="scope">
              {{ scope.row.case_number || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="执行依据文号">
            <template slot-scope="scope">
              {{ scope.row.doc_number || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="执行法院">
            <template slot-scope="scope">
              {{ scope.row.court || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="被执行人履行情况">
            <template slot-scope="scope">
              {{ scope.row.execution_status || "-" }}
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            width="100px"
            fixed="right"
            align="center"
            fit="true"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="查看详情"
                placement="top-start"
              >
                <el-button
                  size="mini"
                  type="primary"
                  icon="el-icon-document"
                  circle
                  @click="showDetail(scope.row)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!--分页模块-->
    <el-row v-if="total > 0" :gutter="20">
      <el-col :xs="24" :sm="24" :md="12" :lg="24" :xl="24">
        <el-card>
          <el-pagination
            :current-page="queryForm.pageNum"
            :page-size="queryForm.pageSize"
            :total="total"
            :background="background"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          ></el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <!--查看详情-->
    <el-dialog
      title="失信被执行"
      :visible.sync="flag"
      :close-on-click-modal="false"
      width="65%"
      append-to-body
      @close="close"
    >
      <table
        class="info-table"
        cellspacing="0"
        style="width: 100%; height: 100%"
      >
        <tbody>
          <tr>
            <td>立案时间</td>
            <td>{{ report.date || "-" }}</td>
            <td>案号</td>
            <td>{{ report.case_number || "-" }}</td>
          </tr>
          <tr>
            <td>执行依据文号</td>
            <td>{{ report.doc_number || "-" }}</td>
            <td>做出执行依据单位</td>
            <td>{{ report.ex_department || "-" }}</td>
          </tr>
          <tr>
            <td>被执行人履行情况</td>
            <td>{{ report.execution_status || "-" }}</td>
            <td>生效法律文书确定的义务</td>
            <td>{{ report.final_duty || "-" }}</td>
          </tr>
          <tr>
            <td>失信被执行人行为具体情形</td>
            <td colspan="3">{{ report.execution_desc || "-" }}</td>
          </tr>
        </tbody>
      </table>
    </el-dialog>
  </div>
</template>

<script>
  import { getDataPost } from "@/api/workplace/companyInfo";

  export default {
    name: "ShiXinBeiZhiXingRen",

    data() {
      return {
        flag: false,
        list: [],
        loading: false,
        total: 0,
        background: true,
        layout: "total, sizes, prev, pager, next, jumper",
        queryForm: {
          body: {
            keyword: "",
            seqId: "",
            skip: 0,
          },
          header: {
            currentTime: "",
            requestId: "2b81a030-bf6c-11ea-a387-f8a2d6d9d88d",
            sourceType: "site",
          },
          pageNum: 1,
          pageSize: 20,
        },
        report: {},
        obj: null,
      };
    },

    methods: {
      getDataPost(param) {
        this.loading = true;
        this.obj = param;
        this.queryForm.body.keyword = param.keyword;
        this.queryForm.body.seqId = param.seqId;
        this.queryForm.body.skip = (this.queryForm.pageNum - 1) * 20;
        getDataPost(this.queryForm)
          .then((response) => {
            if (response.header.retCode === "1") {
              this.list = response.body.items;
              this.total = response.body.total;
            }
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
          });
      },
      handleSizeChange(val) {
        this.queryForm.pageSize = val;
        this.getDataPost(this.obj);
      },
      handleCurrentChange(val) {
        this.queryForm.pageNum = val;
        this.getDataPost(this.obj);
      },
      showDetail(row) {
        this.flag = true;
        this.report = row;
      },
      close() {
        this.flag = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .info-table {
    border-collapse: collapse;
    font-size: 14px;
    color: #333;

    tr td {
      border: 1px solid #ccc;
      padding: 10px;

      &:nth-of-type(even) {
        width: 35%;
        font-weight: normal;
      }

      &:nth-of-type(odd) {
        width: 15%;
        background: #f5f7fa;
      }
    }
  }
</style>
